import { Radio } from 'antd';
import { useCallback, useEffect, useState } from 'react';

import type { ContentType } from '@pages/Clients/NewClientsList/components/MultiFilter/types';

import { useNewClientsListContext } from '@pages/Clients/NewClientsList/context/useNewClientsListContext';
import {
  PF,
  HAS_LOYALTY_CARD_RADIO_OPTIONS,
} from '@pages/Clients/NewClientsList/data/constants';
import { FilterWrapper } from '@pages/Clients/NewClientsList/ui/FilterWrapper';

export const HasLoyaltyCardFilter: ContentType = ({ open, onClose, id }) => {
  const [localHasLoyaltyCard, setLocalHasLoyaltyCard] = useState<
    boolean | null
  >(null);
  const { filtersMap, onChangeFilterById } = useNewClientsListContext();

  const { hasLoyaltyCard } = filtersMap.get(id)!;

  const onConfirm = useCallback(() => {
    if (localHasLoyaltyCard === null) {
      onClose?.();
      return;
    }
    onChangeFilterById(id, 'hasLoyaltyCard', localHasLoyaltyCard);
    onClose?.();
  }, [localHasLoyaltyCard, onChangeFilterById, onClose, id]);

  useEffect(() => {
    if (open) {
      setLocalHasLoyaltyCard(hasLoyaltyCard);
    } else {
      setLocalHasLoyaltyCard(null);
    }
  }, [hasLoyaltyCard, open]);

  return (
    <FilterWrapper onConfirm={onConfirm}>
      <Radio.Group
        value={localHasLoyaltyCard}
        onChange={({ target: { value } }) => setLocalHasLoyaltyCard(value)}
        options={HAS_LOYALTY_CARD_RADIO_OPTIONS}
        className={`${PF}__radio-group`}
      />
    </FilterWrapper>
  );
};
